import React, { useEffect } from "react";
import { Navigate, Route } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch, useSelector } from "react-redux";

import { useProfile } from "../Components/Hooks/UserHooks";

import { logoutUser } from "../slices/auth/login/thunk";
import { getUserDetails } from "../slices/auth/profile/thunk";

const AuthProtected = (props) => {
  const dispatch = useDispatch();
  const { loading, token } = useProfile();

  useEffect(() => {
    try {
      if (!loading && token) {
        setAuthorization(token);
      } else if (loading && !token) {
        dispatch(logoutUser());
      }
    } catch (error) {}
  }, [token, loading, dispatch]);

  useEffect(() => {
    try {
      dispatch(getUserDetails());
    } catch (error) {
      console.log("error", error);

    }
  }, [token, dispatch]);

  if (token === null) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }

  return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return (
          <>
            {" "}
            <Component {...props} />{" "}
          </>
        );
      }}
    />
  );
};

export { AuthProtected, AccessRoute };
